var _style, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDisc = function SvgDisc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "disc_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".disc_svg__st0{fill:none;stroke:#000;stroke-width:2;stroke-miterlimit:10}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "disc_svg__Record"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "disc_svg__st0",
    cx: 24,
    cy: 24,
    r: 23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "disc_svg__st0",
    cx: 24,
    cy: 24,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 2
  }))));
};
export default SvgDisc;